<template>
  <div class="w-full mt-10 md:mt-12 bg-home-banner-bg-2-mobile bg-cover md:bg-home-banner-bg-2-desktop">
    <div class="flex flex-col justify-self-center w-[90%] max-w-[1200px] md:mx-auto md:flex-row items-center mx-5 py-20 gap-10">
      <div class="w-full md:w-1/2 my-3 md:my-0 text-center md:text-start">
        <h2 class="text-ROJO_LEON mx-auto md:ml-0 flex flex-col font-bold text-lg md:text-2xl">
          <span class="flex flex-row items-center justify-center md:justify-start">CON
            <img class="h-4 md:h-6 px-1 mb-1.5" :src="'/img/shared/leon-logo-text.webp'" alt="leon-logo-text" />
          </span>
          <span>OBTIENES MÁS QUE NEUMÁTICOS</span>
        </h2>

        <p class="font-bold my-3 text-lg">Las mejores marcas del mundo</p>
        <p class="md: max-w-[500px]">
          Somos distribuidores oficiales de las mejores marcas de neumáticos y
          contamos con stock permanente.
        </p>
        <NuxtLink @click.native.prevent="scrollToTop" to="/neumaticos"
          class="hidden md:block bg-ROJO_LEON text-white rounded-md font-bold py-2 my-10 hover:bg-GRIS_CLARO_COMPLEMENTARIO_2 hover:text-ROJO_LEON w-1/2 transition mx-auto md:mx-0 text-center">
          Comprar Neumáticos
        </NuxtLink>
      </div>
      <div class="grid grid-cols-2 lg:grid-cols-3 gap-4 mx-auto [&>div]:h-[100px] my-6">
        <div class="w-full bg-white rounded-md flex items-center hover:scale-105 transition p-3 group shadow-lg">
          <img class="group-hover:filter-none" :src="'/img/home/svg_logos_marcas/Michellin.svg'"
            alt="logo-michelin-2" />
        </div>
        <div class="w-full bg-white rounded-md flex items-center hover:scale-105 transition p-3 group shadow-lg">
          <img class="group-hover:filter-none" :src="'/img/home/svg_logos_marcas/Pirelli.svg'" alt="logo_pirelli" />
        </div>
        <div class="w-full bg-white rounded-md flex items-center hover:scale-105 transition p-3 group shadow-lg">
          <img class="group-hover:filter-none" :src="'/img/home/svg_logos_marcas/BRIDGESTONE.svg'"
            alt="logo-bridgestone" />
        </div>
        <div class="w-full bg-white rounded-md flex items-center hover:scale-105 transition p-3 group shadow-lg">
          <img class="group-hover:filter-none" :src="'/img/home/svg_logos_marcas/FIRESTONE.svg'" alt="logo-firestone" />
        </div>
        <div class="w-full bg-white rounded-md flex items-center hover:scale-105 transition p-3 group shadow-lg">
          <img class="group-hover:filter-none" :src="'/img/home/svg_logos_marcas/HANKOOK.svg'" alt="logo-HANKOOK" />
        </div>
        <div class="w-full bg-white rounded-md flex items-center hover:scale-105 transition p-3 group shadow-lg">
          <img class="group-hover:filter-none" :src="'/img/home/svg_logos_marcas/BFGOODRICH.svg'"
            alt="logo-bfgoodrich" />
        </div>

        <div class="w-full bg-white rounded-md flex items-center hover:scale-105 transition p-3 group shadow-lg">
          <img class="group-hover:filter-none" :src="'/img/home/svg_logos_marcas/Continental.svg'"
            alt="logo-continental" />
        </div>
      </div>
      <NuxtLink @click.native.prevent="scrollToTop" to="/neumaticos"
        class="text-center text-white bg-ROJO_LEON w-auto rounded-md py-2 px-1 text-s font-semibold md:hidden hover:bg-GRIS_CLARO_COMPLEMENTARIO_2 hover:text-ROJO_LEON">
        Comprar Neumáticos
      </NuxtLink>
    </div>
  </div>
</template>


<script>
export default {
  setup() {
    const scrollToTop = () => {
      window.scrollTo({
        top: 140,
        behavior: 'smooth'
      });
    };
    return {
      scrollToTop,
    };
  },
};
</script>